
<div class="m-page-loader m-page-loader--base m-page-loader--non-block" style="margin-left: -80px; margin-top: -20px; z-index: 999999999999999999">
	<div class="m-blockui">
		<span>
			loading...
		</span>
		<span>
			<div class="m-loader m-loader--skin-dark"></div>
		</span>
	</div>
</div>

<router-outlet></router-outlet>

